import React, { useCallback, useEffect, useState } from "react";
import { Collapse,Switch,theme, Select, Segmented, Button, Typography } from "antd";
import { WidgetsConceptsFilterContent } from "./WidgetsConceptsFilterContent";
import { WidgetsValuesFilterContent } from "./WidgetsValueFilterContent";
import { WidgetsDatesFilterContent } from "./WidgetsDatesFilterContent";
import { CollapseIcon, ExpandIcon } from "../../../icons";
import { useParams } from "react-router-dom";
import {
    useGetConceptMetaDataQuery,
    useGetConceptsListQuery,
} from "../../../store/api/lumi/concepts";
import { useDispatch, useSelector } from "react-redux";
import { selectDashboardById } from "../../../store/selectors/selectors";
import {
    setActiveConceptList,
    setDeselection,
    setDeselectionConcepts,
    setDeselectionDate,
    setSelections,
    setTopConceptList,
    setTopConceptListDaylight,
    setTopConcepts,
    setTopFilters,
} from "../../../store/slices/dashboardSlice";
import {
    FilterValueSelector,
    FilterNameSelector,
    ConceptsSelector,
    MatchTypeSelector,
    PageSizeSelector,
    FilterDriverFieldSelector,
    FilterOverTimeSelector,
    CombinedConceptSelector,
    IncludeExamples,
    VisualizeSelector,
    ValueSelectInput,
} from "./shared";
import { WidgetNames } from "../../../constants/WidgetNames";
import { ScoreFilterWithInterval } from "./shared/ScoreFilterWithInterval";
import { NPSOverTimeFilter } from "./shared/NPSOverTimeFilter";
import { FilterDateSelector } from "./shared/FilterDateSelector";
import { CloseOutlined } from "@ant-design/icons";

const { Text, Title } = Typography;

export const WidgetFiltersPanel = ({ props, additionalFilters, onClose }) => {
    const {
        metaDataQu,
        dataList,
        sentimentDisabled,
        conceptTypeDay,
        conceptList,
        setConceptList,
        setSelectedLocalConcepts,
        selectedLocalConcepts,
        localConceptOptions,
        selectedFieldName,
        setSelectedFieldName,
        selectedFieldValue,
        setSelectedFieldValue,
        fieldValues,
        filters,
        setFilters,
        selectedDateField,
        selectedPageSize,
        setItemsPerPage,
        selectedFieldDriverName,
        setSelectedFieldDriverName,
        interval,
        setIntervalDate,
        selectedDateName,
        setSelectedDateName,
        includeExamples,
        setIncludeExamples,
        visualizeType,
        setVisualizeType,
        driverInterval,
        setDriverInterval,
        widget,
        smoothLine,
        setSmoothLine,
        setDisplayName,
    } = props;

    const [selectedFilterValues, setSelectedFilterValues] = useState({
        city: [],
        count: [],
        name: [],
        rating: [],
        location: [],
        state: [],
        username: [],
    });

    useEffect(() => {
        const updatedSelectedFilterValues = {
            city: metaDataQu?.metaData?.find((el) => el.name === "City")?.values?.filter((city) => selectedFieldValue.includes(city.value)),
            count: metaDataQu?.metaData?.find((el) => el.name === "Count People Found Review Helpful")?.values?.filter((count) => selectedFieldValue.includes(count.value)),
            name: metaDataQu?.metaData?.find((el) => el.name === "Name")?.values?.filter((name) => selectedFieldValue.includes(name.value)),
            rating: metaDataQu?.metaData?.find((el) => el.name === "Overall Rating")?.values?.filter((rating) => selectedFieldValue.includes(rating.value)),
            location: metaDataQu?.metaData?.find((el) => el.name === "Place Location")?.values?.filter((location) => selectedFieldValue.includes(location.value)),
            state: metaDataQu?.metaData?.find((el) => el.name === "State")?.values?.filter((state) => selectedFieldValue.includes(state.value)),
            username: metaDataQu?.metaData?.find((el) => el.name === "User Name")?.values?.filter((username) => selectedFieldValue.includes(username.value)),
        }
        setSelectedFilterValues((prevValues) => ({
            ...prevValues,
            ...updatedSelectedFilterValues
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChangeType = (type) => {
        props.setConceptTypeDay(type);
        setConceptList("");
    };

    const filterValueItems = {
        city: {
            key: "city",
            label: "City:",
            options: [],
            value: [],
        },
        count: {
            key: "count",
            label: "Count People Found Review Helpful:",
            options: [],
            value: [],
        },
        name: {
            key: "name",
            label: "Name:",
            options: [],
            value: [],
        },
        rating: {
            key: "rating",
            label: "Overall Rating:",
            options: [],
            value: [],
        },
        location: {
            key: "location",
            label: "Place Location:",
            options: [],
            value: [],
        },
        state: {
            key: "state",
            label: "State:",
            options: [],
            value: [],
        },
        username: {
            key: "username",
            label: "User Name:",
            options: [],
            value: [],
        },
    }

    const getMetadataValues = (type) => {
        if (type === "City") {
            return metaDataQu?.metaData?.find((el) => el.name === "City")?.values;
        }
        if (type === "Count People Found Review Helpful") {
            return metaDataQu?.metaData?.find(
                (el) => el.name === "Count People Found Review Helpful"
            )?.values;
        }
        if (type === "Name") {
            return metaDataQu?.metaData?.find((el) => el.name === "Name")?.values;
        }
        if (type === "Overall Rating") {
            return metaDataQu?.metaData?.find(
                (el) => el.name === "Overall Rating"
            )?.values;
        }
        if (type === "Place Location") {
            return metaDataQu?.metaData?.find(
                (el) => el.name === "Place Location"
            )?.values;
        }
        if (type === "State") {
            return metaDataQu?.metaData?.find((el) => el.name === "State")?.values;
        }
        if (type === "User Name") {
            return metaDataQu?.metaData?.find((el) => el.name === "User Name")
                ?.values;
        }
    }

    const handleChangeValueSelect = (value, type) => {
        console.log("handleChangeValueSelect=>", value);
        let updatedValue = {};
        if (type === "City") {
            updatedValue = { city: value };
        }
        if (type === "Count People Found Review Helpful") {
            updatedValue = { count: value };
        }
        if (type === "Name") {
            updatedValue = { name: value };
        }
        if (type === "Overall Rating") {
            updatedValue = { rating: value };
        }
        if (type === "Place Location") {
            updatedValue = { location: value };
        }
        if (type === "State") {
            updatedValue = { state: value };
        }
        if (type === "User Name") {
            updatedValue = { username: value };
        }
        // TODO: fix state persistence issue
        setSelectedFieldValue([
            ...((type === "City") ? value : selectedFilterValues.city),
            ...((type === "Count People Found Review Helpful") ? value : selectedFilterValues.count),
            ...((type === "Name") ? value : selectedFilterValues.name),
            ...((type === "Overall Rating") ? value : selectedFilterValues.rating),
            ...((type === "Place Location") ? value : selectedFilterValues.location),
            ...((type === "State") ? value : selectedFilterValues.state),
            ...((type === "User Name") ? value : selectedFilterValues.username),
        ]);
        setSelectedFilterValues((prevValues) => ({
            ...prevValues,
            ...updatedValue,
        }));
    };

    const getFilterValueItems = () => {
        const items = [];
        if (selectedFieldName.includes("City")) {
            items.push({
                key: filterValueItems.city.key,
                label: <Text strong>{filterValueItems.city.label}</Text>,
                children: (
                    <ValueSelectInput
                        name={filterValueItems.city.key}
                        placeholder="Select City"
                        options={getMetadataValues("City")}
                        value={selectedFilterValues.city}
                        onChangeValueSelect={(value) =>
                            handleChangeValueSelect(value, "City")
                        }
                    />
                ),
                showArrow: false,
            });
        }
        if (selectedFieldName.includes("Count People Found Review Helpful")) {
            items.push({
                key: filterValueItems.count.key,
                label: <Text strong>{filterValueItems.count.label}</Text>,
                children: (
                    <ValueSelectInput
                        name={filterValueItems.count.key}
                        placeholder="Select Count"
                        options={getMetadataValues(
                            "Count People Found Review Helpful"
                        )}
                        value={selectedFilterValues.count}
                        onChangeValueSelect={(value) =>
                            handleChangeValueSelect(
                                value,
                                "Count People Found Review Helpful"
                            )
                        }
                    />
                ),
                showArrow: false,
            });
        }
        if (selectedFieldName.includes("Name")) {
            items.push({
                key: filterValueItems.name.key,
                label: <Text strong>{filterValueItems.name.label}</Text>,
                children: (
                    <ValueSelectInput
                        name={filterValueItems.name.key}
                        placeholder="Select Name"
                        options={getMetadataValues("Name")}
                        value={selectedFilterValues.name}
                        onChangeValueSelect={(value) =>
                            handleChangeValueSelect(value, "Name")
                        }
                    />
                ),
                showArrow: false,
            });
        }
        if (selectedFieldName.includes("Overall Rating")) {
            items.push({
                key: filterValueItems.rating.key,
                label: <Text strong>{filterValueItems.rating.label}</Text>,
                children: (
                    <ValueSelectInput
                        name={filterValueItems.rating.key}
                        placeholder="Select Overall Rating"
                        options={getMetadataValues("Overall Rating")}
                        value={selectedFilterValues.rating}
                        onChangeValueSelect={(value) =>
                            handleChangeValueSelect(value, "Overall Rating")
                        }
                    />
                ),
                showArrow: false,
            });
        }
        if (selectedFieldName.includes("Place Location")) {
            items.push({
                key: filterValueItems.location.key,
                label: <Text strong>{filterValueItems.location.label}</Text>,
                children: (
                    <ValueSelectInput
                        name={filterValueItems.location.key}
                        placeholder="Select Place Location"
                        options={getMetadataValues("Place Location")}
                        value={selectedFilterValues.location}
                        onChangeValueSelect={(value) =>
                            handleChangeValueSelect(value, "Place Location")
                        }
                    />
                ),
                showArrow: false,
            });
        }
        if (selectedFieldName.includes("State")) {
            items.push({
                key: filterValueItems.state.key,
                label: <Text strong>{filterValueItems.state.label}</Text>,
                children: (
                    <ValueSelectInput
                        name={filterValueItems.state.key}
                        placeholder="Select State"
                        options={getMetadataValues("State")}
                        value={selectedFilterValues.state}
                        onChangeValueSelect={(value) =>
                            handleChangeValueSelect(value, "State")
                        }
                    />
                ),
                showArrow: false,
            });
        }
        if (selectedFieldName.includes("User Name")) {
            items.push({
                key: filterValueItems.username.key,
                label: <Text strong>{filterValueItems.username.label}</Text>,
                children: (
                    <ValueSelectInput
                        name={filterValueItems.username.key}
                        placeholder="Select User Name"
                        options={getMetadataValues("User Name")}
                        value={selectedFilterValues.username}
                        onChangeValueSelect={(value) =>
                            handleChangeValueSelect(value, "User Name")
                        }
                    />
                ),
                showArrow: false,
            });
        }
        return items;
    };

    const getDateFilterValueItems = () => {
        const items = [];
        if (selectedFieldName.includes("Date Created")) {
            items.push({
                key: "dates",
                label: <Text strong>Dates:</Text>,
                children: (
                    <FilterDateSelector
                        setFilters={setFilters}
                        selectedDateField={selectedDateField}
                        dateTypeMetadata={props.dateTypeMetadata}
                        filters={filters}
                    />
                ),
                showArrow: false,
            });
        }
        return items;
    };

    const filterItems = {
            conceptLists: {
                key: "conceptLists",
                label: <Text strong>Concept Lists:</Text>,
                children: (
                    <CombinedConceptSelector
                        sentimentDisabled={sentimentDisabled}
                        handleChangeType={handleChangeType}
                        conceptTypeDay={conceptTypeDay}
                        conceptList={conceptList}
                        setConceptList={setConceptList}
                        setSelectedLocalConcepts={setSelectedLocalConcepts}
                        conceptLists={dataList}
                    />
                ),
                showArrow: false,
            },
            concepts: {
                key: "concepts",
                label: <Text strong>Concepts:</Text>,
                children: (
                    <ConceptsSelector
                        selectedLocalConcepts={selectedLocalConcepts}
                        setSelectedLocalConcepts={setSelectedLocalConcepts}
                        localConceptOptions={localConceptOptions}
                        setConceptList={setConceptList}
                    />
                ),
                showArrow: false,
            },
            matchType: {
                key: "matchType",
                label: <Text strong>Match Type:</Text>,
                children: (
                    <MatchTypeSelector
                        selectedType={props.seletctedType}
                        setSelectedType={props.setSeletctedType}
                    />
                ),
                showArrow: false,
            },
            filterName: {
                key: "filterName",
                label: <Text strong>Filter Name:</Text>,
                children: (
                    <FilterNameSelector
                        mode={"multiple"}
                        selectedFieldName={selectedFieldName}
                        setSelectedFieldName={setSelectedFieldName}
                        metaData={metaDataQu?.metaData}
                    />
                ),
                showArrow: false,
            },
            filterValue: {
                key: "filterValue",
                label: <Text strong>Filter Value:</Text>,
                children: (
                    <FilterValueSelector
                        dateTypeMetadata={props.dateTypeMetadata}
                        selectedFieldName={selectedFieldName}
                        selectedFieldValue={selectedFieldValue}
                        setSelectedFieldValue={setSelectedFieldValue}
                        fieldValues={fieldValues}
                        setFilters={setFilters}
                        filters={filters}
                        selectedDateField={selectedDateField}
                        metaDataDate={metaDataQu?.metaDataDate}
                    />
                ),
                showArrow: false,
            },
            pageSize: {
                key: "pageSize",
                label: <Text strong>Page Size:</Text>,
                children: (
                    <PageSizeSelector
                        selectedPageSize={selectedPageSize}
                        setSelectedPageSize={setItemsPerPage}
                    />
                ),
                showArrow: false,
            },
    
            filterDriver: {
                key: "filterDriver",
                label: <Text strong>Filter Driver Field:</Text>,
                children: (
                    <FilterDriverFieldSelector
                        selectedFieldDriverName={selectedFieldDriverName}
                        setSelectedFieldDriverName={setSelectedFieldDriverName}
                        metaDataDrivers={metaDataQu?.metaDataDrivers}
                    />
                ),
                showArrow: false,
            },
            filterScore: {
                key: "filterScore",
                label: <Text strong>Filter Score:</Text>,
                children: (
                    <FilterDriverFieldSelector
                        widget={widget}
                        setDisplayName={setDisplayName}
                        selectedFieldDriverName={selectedFieldDriverName}
                        setSelectedFieldDriverName={setSelectedFieldDriverName}
                        metaDataDrivers={metaDataQu?.metaDataDrivers}
                    />
                ),
                showArrow: false,
            },
            overTime: {
                key: "overTime",
                label: <Text strong>Over Time:</Text>,
                children: (
                    <FilterOverTimeSelector
                        interval={interval}
                        filters={filters}
                        setInterval={setIntervalDate}
                        selectedDateName={selectedDateName}
                        setSelectedDateName={setSelectedDateName}
                        metaDataDate={metaDataQu?.metaDataDate}
                        selectedDateField={selectedDateField}
                    />
                ),
                showArrow: false,
            },
            includeExamples: {
                key: "includeExamples",
                label: <Text strong>Include examples:</Text>,
                children: (
                    <IncludeExamples
                        selectedOption={includeExamples}
                        onChange={setIncludeExamples}
                    />
                ),
                showArrow: false,
            },
            visualizeMatches: {
                key: "visualizeMatches",
                label: <Text strong>Visualize matches as:</Text>,
                children: (
                    <VisualizeSelector
                        selectedType={visualizeType}
                        setSelectedType={setVisualizeType}
                    />
                ),
                showArrow: false,
            },
            scoreFilterWithIntervals: {
                key: "scoreFilterWithIntervals",
                label: <Text strong>Select Score/Number:</Text>,
                children: (
                    <ScoreFilterWithInterval
                        widget={widget}
                        setDisplayName={setDisplayName}
                        selectedFieldDriverName={selectedFieldDriverName}
                        setSelectedFieldDriverName={setSelectedFieldDriverName}
                        metaDataDrivers={metaDataQu?.metaDataDrivers}
                        metadata={metaDataQu.metaData}
                        setDriverInterval={setDriverInterval}
                        driverInterval={driverInterval}
                    />
                ),
                showArrow: false,
            },
            npsScoreFilter: {
                key: "npsScoreFilter",
                label: <Text strong>Select Score/Number:</Text>,
                children: (
                    <NPSOverTimeFilter
                        widget={widget}
                        setDisplayName={setDisplayName}
                        selectedFieldDriverName={selectedFieldDriverName}
                        setSelectedFieldDriverName={setSelectedFieldDriverName}
                        metaData={metaDataQu}
                    />
                ),
                showArrow: false,
            },
        };
    const getStaticCollapsedData = () => {
            const sharedFilters = [
                filterItems.conceptLists,
                filterItems.concepts,
                filterItems.filterName,
                ...getFilterValueItems(),
                ...getDateFilterValueItems(),
                // filterItems.filterValue,
                filterItems.pageSize,
            ];
            const overTimeFilters = [...sharedFilters, filterItems.overTime];
            const driverFilters = [
                filterItems.filterScore,
                ...sharedFilters,
                filterItems.matchType,
            ];
            const volumeFilters = [
                ...sharedFilters,
                filterItems.matchType,
                filterItems.visualizeMatches,
            ];
    
            switch (props.widget.text) {
                case WidgetNames.NUMBER_METADATA_BREAKDOWN:
                case WidgetNames.NPS_BREAKDOWN:
                    return [
                        filterItems.scoreFilterWithIntervals,
                        filterItems.filterName,
                        filterItems.filterValue,
                    ];
                case WidgetNames.NPS_SCORE_OVERTIME:
                    return [
                        filterItems.filterName,
                        filterItems.filterValue,
                        filterItems.overTime,
                    ];
                case WidgetNames.NPS_SCORE:
                    return [
                        filterItems.npsScoreFilter,
                        filterItems.filterName,
                        filterItems.filterValue,
                    ];
                case WidgetNames.SENTIMENT:
                case WidgetNames.SENTIMENT_SHARE_BAR_CHART:
                case WidgetNames.SENTIMENT_SHARE:
                    return sharedFilters;
                case WidgetNames.NET_SENTIMENT_FOR_CONCEPT_OVER_TIME:
                case WidgetNames.SENTIMENT_OVER_TIME_LINE:
                    return overTimeFilters;
                case WidgetNames.VOLUME:
                    return [...sharedFilters];
                case WidgetNames.OVERALL_SENTIMENT:
                    return [...sharedFilters];
                case WidgetNames.LARGEST_CONCEPT_MOVEMENT:
                    return [
                        ...sharedFilters,
                        filterItems.matchType,
                        filterItems.overTime,
                    ];
                case WidgetNames.LARGEST_NET_SENTIMENT_MOVEMENT:
                    return [...overTimeFilters];
                case WidgetNames.IMPACT_SCORE:
                case WidgetNames.DRIVERS:
                    return driverFilters;
                case WidgetNames.AVERAGE_SCORE_OVERTIME:
                    return [
                        filterItems.filterScore,
                        filterItems.filterName,
                        filterItems.filterValue,
                        filterItems.overTime,
                    ];
                case WidgetNames.DRIVERS_DIFFERENCE_FROM_AVERAGE:
                case WidgetNames.DRIVERS_OVER_TIME:
                case WidgetNames.LARGEST_DRIVERS_MOVEMENT:
                    return [filterItems.filterScore, ...overTimeFilters];
                case WidgetNames.METADATA_SHARE_OF_VOICE_OVER_TIME:
                    return [filterItems.overTime];
                case WidgetNames.VOLUME_OVER_TIME:
                case WidgetNames.SHARE_OF_VOICE_OVER_TIME_BUBBLE:
                    return [...sharedFilters, filterItems.overTime];
                case WidgetNames.SHARE_OF_VOICE_OVER_TIME:
                    return [...volumeFilters, filterItems.overTime];
                case WidgetNames.OUTLIER_PERCENTAGE:
                    return [filterItems.conceptLists, filterItems.filterScore];
                case WidgetNames.DOCUMENTS:
                    return [filterItems.filterName, filterItems.filterValue];
                case WidgetNames.AVERAGE_SCORE:
                    return [
                        filterItems.filterScore,
                        filterItems.filterName,
                        filterItems.filterValue,
                    ];
                case WidgetNames.METADATA_CONCEPT_VOLUME:
                    return [
                        filterItems.conceptLists,
                        filterItems.concepts];
                case WidgetNames.METADATA_SENTIMENT_BREAKDOWN:
                    return [];
                case WidgetNames.METADATA_DRIVERS_BREAKDOWN:
                        return [];
                default:
                    return [];
            }
        };
    const staticCollapsedData = [
        ...getStaticCollapsedData(),
        ...additionalFilters,
    ];

    const defaultActiveKeys = staticCollapsedData
        .filter(
            (item) =>
                item.key === "filterScore" ||
                item.key === "scoreFilterWithIntervals" ||
                item.key === "Special" ||
                item.key === "npsScoreFilter"
        )
        .map((item) => item.key);
    //##

    const { token } = theme.useToken();
    const { id, dashboardName: nameFromParams } = useParams();
    // const { data: dataList, isLoading } = useGetConceptsListQuery(id);
    const { data: metadataResponse, isSuccess } =
        useGetConceptMetaDataQuery(id);
        const [matchType, setMatchType] = useState("Both");
        const [pageSize, setPageSize] = useState(null);

    const dispatch = useDispatch();

    const {
        topFilters = [],
        selections = {},
        topConcepts = [],
        activeConceptList = "",
    } = useSelector((state) => selectDashboardById(state, id));

    const { topOptionsConcepts} = useSelector(
        (state) => state.project
    );
    //#

    const dispatchSetFilters = useCallback(
        (filterData) => {
            dispatch(setTopFilters({ id, filters: [filterData] }));
        },
        [dispatch, id]
    );

    const dispatchSetSelections = useCallback(
        (selectionData) => {
            dispatch(setSelections({ id, selections: selectionData }));
        },
        [dispatch, id]
    );

    const dispatchSetTopConcepts = useCallback(
        (concepts) => {
            dispatch(setTopConcepts({ id, concepts }));
        },
        [dispatch, id]
    );

    const handleConceptsChange = useCallback(
        (newConcepts) => {
            dispatchSetTopConcepts(newConcepts);
        },
        [dispatchSetTopConcepts]
    );

    const dispatchSetDeselection = useCallback(
        (deselection) => {
            dispatch(setDeselection({ id, deselection }));
        },
        [dispatch, id]
    );

    const dispatchSetDeselectionConcepts = (deselectionConcepts) => {
        dispatch(setDeselectionConcepts({ id, deselectionConcepts }));
    };
    const handleConceptListChange = useCallback(
        (list) => {
            dispatch(setTopConceptList({ id, list }));
            dispatch(setActiveConceptList({ id, list }));
        },
        [dispatch, id]
    );

    const handleChangeConceptListType = useCallback(
        (type) => {
            dispatch(setTopConceptListDaylight({ id, daylight: type }));
            dispatch(setActiveConceptList({ id, list: `Type: ${type}` }));
        },
        [dispatch, id]
    );

    const handleFilter = useCallback(
        (item, newValue) => {
            const previousValues = selections[item.name]?.values || [];
            const deselectedValues = previousValues.filter(
                (x) => !newValue.includes(x)
            );

            if (deselectedValues.length > 0) {
                dispatchSetDeselection({
                    name: item.name,
                    values: deselectedValues,
                    type: item.type,
                });
            }

            dispatchSetSelections({
                [item.name]: {
                    type: item.type,
                    values: newValue,
                },
            });
        },
        [dispatchSetSelections, selections, dispatchSetDeselection]
    );

    const dispatchSetDeselectionDate = (deselectionDate) => {
        dispatch(setDeselectionDate({ id, deselectionDate }));
    };

    const handleDateDeselection = (dateField) => {
        dispatchSetDeselectionDate(dateField);
    };

    const dateMetadata = metadataResponse?.metaDataDate?.map(
        (el) => el.name,
        []
    );

    useEffect(() => {
        const filterArray = Object?.entries(selections).reduce(
            (acc, [name, { type, values = [] }]) => {
                if (type === "number" && values.length > 0) {
                    const numValues = values.map(Number);
                    acc.push({
                        name,
                        minimum: Math.min(...numValues),
                        maximum: Math.max(...numValues),
                    });
                } else if (
                    type === "date" &&
                    values.minimum &&
                    values.maximum
                ) {
                    acc.push({
                        name,
                        minimum: new Date(values.minimum).toISOString(),
                        maximum: new Date(values.maximum).toISOString(),
                    });
                } else if (values.length > 0) {
                    acc.push({ name, values });
                }
                return acc;
            },
            []
        );
        if (topFilters) {
            topFilters.forEach((filter) => {
                if (dateMetadata.includes(filter.name)) {
                    filterArray.push(filter);
                }
            });
        }
        const areFiltersEqual =
            JSON.stringify(filterArray) === JSON.stringify(topFilters);
        if (!areFiltersEqual) {
            dispatch(setTopFilters({ id, filters: filterArray }));
        }
    }, [selections, topFilters, dateMetadata, dispatch, id]);

    const valuesFilterMetadata =
        metadataResponse?.metaData?.filter((item) => item.type !== "date") ||
        [];
    const datesFilterMetadata =
        metadataResponse?.metaData?.find((item) => item.type === "date") || [];

    return (
        <div className="filter-panel filter-widget">
            <div className="filter-top">
                <div>
                    <Title level={4} style={{ margin: 0 }}>
                        Filters
                    </Title>
                    <Text>Applicable only to your current selection</Text>
                </div>
                <Button
                    type="text"
                    icon={<CloseOutlined />}
                    style={{ padding: 0 }}
                    onClick={() => onClose()}
                />
            </div>
            <div className="filter-content">
                <Collapse
                    accordion
                    style={{
                        background: "none",
                        fontSize: token.fontSizeLG,
                        color: "#090A09",
                    }}
                    bordered={false}
                    defaultActiveKey={[]}
                    // expandIcon={({ isActive }) =>
                    //     isActive ? <CollapseIcon /> : <ExpandIcon />
                    // }
                    expandIconPosition="end"
                    // items={[
                    //     {
                    //         key: "1",
                    //         label: (
                    //             <span
                    //                 style={{
                    //                     fontSize: token.fontSizeLG,
                    //                     fontWeight: "600",
                    //                     color: "#090A09",
                    //                 }}
                    //             >
                    //                 Widget Filters
                    //             </span>
                    //         ),
                    //         children: (
                    //             <div onMouseDown={(e) => e.stopPropagation()}>
                    //                 <Collapse
                    //                     onMouseDown={(e) => e.stopPropagation()}
                    //                     items={staticCollapsedData.map((item) => ({
                    //                         ...item,
                    //                         children: (
                    //                             <div>{item.children}</div>
                    //                         ),
                    //                     }))}
                    //                     accordion={true}
                    //                     bordered={false}
                    //                     defaultActiveKey={defaultActiveKeys}
                    //                     style={{
                    //                         background: "none"
                    //                     }}
                    //                 />
                    //                 {widget.gridData.lineChart && (
                    //                     <div
                    //                         style={{
                    //                             position: "absolute",
                    //                             left: "33%",
                    //                             alignItems: "center",
                    //                             bottom: "5%",
                    //                         }}
                    //                         onMouseDown={(e) => e.stopPropagation()}
                    //                     >
                    //                         <Switch
                    //                             checked={smoothLine}
                    //                             onChange={setSmoothLine}
                    //                             checkedChildren="Smooth"
                    //                             unCheckedChildren="Straight"
                    //                         />
                    //                     </div>
                    //                 )}
                    //             </div>
                    //         ),
                    //     },
                    // ]}
                    items={staticCollapsedData.map((item) => ({
                        ...item,
                        children: <div>{item.children}</div>,
                    }))}
                />
            </div>
            <div className="filter-bottom">
                <Button
                    onClick={() => {
                        setSelectedFieldValue([]);
                    }}
                    disabled={
                        !selectedFieldValue || selectedFieldValue.length === 0
                    }
                >
                    Clear
                </Button>
            </div>
            {/* <div style={{ display: "flex", flexDirection: "column", gap: "12px", padding:"20px", marginTop:"auto" }}> */}
            {/* Match Type Toggle */}
            {/* <div className="segment-option">
                    <p style={{ fontWeight: "bold", marginBottom: "6px" }}>Match Type</p>
                    <Segmented options={['Both', 'Exact', 'Conceptual']} value={matchType} onChange={setMatchType} />
                </div> */}

            {/* Page Size Dropdown */}
            {/* <div>
                    <p style={{ fontWeight: "bold", marginBottom: "6px" }}>Page Size</p>
                    <Select
                        value={pageSize}
                        placeholder="Placeholder"
                        onChange={setPageSize}
                        options={[
                            { value: 10, label: "10" },
                            { value: 20, label: "20" },
                            { value: 50, label: "50" }
                        ]}
                        style={{ width: "100%" }}
                    />
                </div> */}
            {/* </div> */}
        </div>
    );
};
